import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiRoutes } from '../apiroutes';
import { BackendListModel } from '../../models/common/list.model';
import { Observable } from 'rxjs';
import { InsuranceModel } from 'src/app/components/external-dashboards/quoteTable/base-quote.model';

@Injectable({
  providedIn: 'root'
})
export class InsuranceApiService {
  base_url = ApiRoutes.Insurance;
  insurance_search_url = ApiRoutes.Insurance + 'insurance/?search=::search::';

  constructor(
    private http: HttpClient
  ) { }

  getList(page_number = 1, page_size = 10): Observable<BackendListModel<InsuranceModel>> {
    let url = new URL(`${this.base_url}insurance/`);
    url.searchParams.append('page_number', page_number.toString());
    url.searchParams.append('page_size', page_size.toString());
    return this.http.get<BackendListModel<InsuranceModel>>(url.toString());
  }
}
